// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServiceContracts-module_resource_label__ZHAS {
  font-size: 16px;
  font-weight: 600;
}

.ServiceContracts-module_resource_name_Tx4AS {
  /* composes: resource_label; */
  cursor: pointer;
  color: var(--primary-bos-color);
}

.ServiceContracts-module_resource_box_UpTYR {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--bp-light-gray1);
  padding: 12px;
  flex-grow: 1;
}

.ServiceContracts-module_label_and_value_box_GI5KW {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  flex-grow: 1;
}

.ServiceContracts-module_resource_docs_container_zV6z4 {
  /* margin: 0 20px; */
  margin-top: 10px;
  border-top: 1px solid var(--primary-bos-color);
  flex-grow: 1;
  /* border-top: 1px solid var(--bp-light-gray1); */
}

.ServiceContracts-module_documents_header_BZ5v7 {
  color: var(--text-color);
  margin-bottom: 8px;
  font-size: 15px;
  line-height: 19px;
  width: 100%;
  font-weight: 600;
  text-align: center;
  padding-top: 10px;
}

.ServiceContracts-module_link_resource_button_XVlS6 {
}

.ServiceContracts-module_panel_content_box_vertical_HKwYJ {
}

.ServiceContracts-module_panel_flex_box_cZiBY {
}

.ServiceContracts-module_half_panel_iBJ0C {
}

.ServiceContracts-module_full_width_panel_BMKyG {
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/ServiceContracts/ServiceContracts.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uCAAuC;EACvC,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,8CAA8C;EAC9C,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":[".resource_label {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.resource_name {\n  /* composes: resource_label; */\n  cursor: pointer;\n  color: var(--primary-bos-color);\n}\n\n.resource_box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  border: 1px solid var(--bp-light-gray1);\n  padding: 12px;\n  flex-grow: 1;\n}\n\n.label_and_value_box {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  flex-grow: 1;\n}\n\n.resource_docs_container {\n  /* margin: 0 20px; */\n  margin-top: 10px;\n  border-top: 1px solid var(--primary-bos-color);\n  flex-grow: 1;\n  /* border-top: 1px solid var(--bp-light-gray1); */\n}\n\n.documents_header {\n  color: var(--text-color);\n  margin-bottom: 8px;\n  font-size: 15px;\n  line-height: 19px;\n  width: 100%;\n  font-weight: 600;\n  text-align: center;\n  padding-top: 10px;\n}\n\n.link_resource_button {\n  composes: primary_button_outlined from 'Styles/styles.module.css';\n}\n\n.panel_content_box_vertical {\n  composes: panel_content_box_vertical from 'Styles/styles.module.css';\n}\n\n.panel_flex_box {\n  composes: panel_flex_box from 'Styles/styles.module.css';\n}\n\n.half_panel {\n  composes: half_panel from 'Styles/styles.module.css';\n}\n\n.full_width_panel {\n  composes: full_width_panel from 'Styles/styles.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"resource_label": `ServiceContracts-module_resource_label__ZHAS`,
	"resource_name": `ServiceContracts-module_resource_name_Tx4AS`,
	"resource_box": `ServiceContracts-module_resource_box_UpTYR`,
	"label_and_value_box": `ServiceContracts-module_label_and_value_box_GI5KW`,
	"resource_docs_container": `ServiceContracts-module_resource_docs_container_zV6z4`,
	"documents_header": `ServiceContracts-module_documents_header_BZ5v7`,
	"link_resource_button": `ServiceContracts-module_link_resource_button_XVlS6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_outlined"]}`,
	"panel_content_box_vertical": `ServiceContracts-module_panel_content_box_vertical_HKwYJ ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panel_content_box_vertical"]}`,
	"panel_flex_box": `ServiceContracts-module_panel_flex_box_cZiBY ${___CSS_LOADER_ICSS_IMPORT_0___.locals["panel_flex_box"]}`,
	"half_panel": `ServiceContracts-module_half_panel_iBJ0C ${___CSS_LOADER_ICSS_IMPORT_0___.locals["half_panel"]}`,
	"full_width_panel": `ServiceContracts-module_full_width_panel_BMKyG ${___CSS_LOADER_ICSS_IMPORT_0___.locals["full_width_panel"]}`
};
export default ___CSS_LOADER_EXPORT___;
